import HardwareSerializer from 'eflex/serializers/hardware';

export default class AdamIoSerializer extends HardwareSerializer {}
